import gql from "graphql-tag";
import { ApolloError, useLazyQuery } from "@apollo/client";
import { useEffect } from "react";
import { PspPaymentState } from "src/types/graphql.d";

interface PspPaymentStateData {
  pspPaymentState: PspPaymentState;
}

interface PspPaymentStateVars {
  payment_id: string;
}

export interface PspPaymentStateHook {
  paymentStateData: PspPaymentState | undefined;
  loading: boolean;
  error: ApolloError | undefined;
}

export const GET_PSP_PAYMENT_STATE = gql`
  query pspPaymentState($payment_id: String!) {
    pspPaymentState(payment_id: $payment_id) {
      id
      state
      method
    }
  }
`;
const usePspPaymentState = (
  paymentId?: string
): PspPaymentStateHook | undefined => {
  const [loadPaymentState, { loading, error, data }] = useLazyQuery<
    PspPaymentStateData,
    PspPaymentStateVars
  >(GET_PSP_PAYMENT_STATE, {
    variables: {
      payment_id: paymentId || "",
    },
    pollInterval: 2000,
  });

  useEffect(() => {
    if (!paymentId) {
      return;
    }

    void loadPaymentState();
  }, [paymentId, loadPaymentState]);

  const paymentStateData = data?.pspPaymentState;

  return { paymentStateData, loading, error };
};

export { usePspPaymentState };
